<template>
    <div>
        <button type="button" @click="appendDataToModal" class="btn btn-sm btn-clean btn-icon btn-icon-sm"
                data-toggle="modal" data-target="#description_modal">
            <i class="fa fa-info" title="خطای رد تسویه"></i>
        </button>

        <div id="description_modal" class="modal fade rtl" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <div id="shRequest_title"></div>
                        <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                    </div>
                    <div id="data_sheet" class="modal-body mb-4">
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th class="table-info" colspan="2">{{ $t('settlement.rejection_reason') }}</th>
                            </tr>
                            </thead>
                            <tbody id="rejection_reason">
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import $ from 'jquery'
    import { i18n } from '@/plugins/i18n'

    export default Vue.extend({
        props: {
            row: {
                required: true,
            },
            index: {
                required: true,
            },
            datatable: {
                required: true,
            }
        },
        methods: {
            appendDataToModal() {
                let rejection_reasons = $('#rejection_reason').empty()
                let shRequest_title = $('#shRequest_title').empty()

                let ps_elements =
                    '<h4 class="modal-title float-right p-0 m-0">' +
                    i18n.t('settlement.rejected_settlement')+ ' ' + this.row.id + '</h4>'

                shRequest_title.append (ps_elements)

                ps_elements = ''
                if (this.row.rejection_reasons) {
                    for (let $i=0; $i < this.row.rejection_reasons.length; $i++)
                    ps_elements += simpleText(this.row.rejection_reasons[$i].fieldName ,
                        this.row.rejection_reasons[$i].fieldValue, this.row.rejection_reasons[$i].errorMessage)
                }
                rejection_reasons.append (ps_elements)

                function simpleText(fieldName, fieldValue, errorMessage){
                    return  '</tr><tr><td>' + errorMessage + '</td><td style="direction: ltr">' + "errorMessage:" + '</td></tr>' +
                        '<tr><td style="width: 155px;">' + fieldValue + '</td>' + '<td style="direction: ltr">' + fieldName + ":" + '</td>'
                }
            }
        }
    })
</script>

<style>

</style>